import React, { useState } from "react";
import ShareButton from "../shared/ShareButton";
import RatingModal from "../shared/RatingModal";
import RatingButton from "../shared/RatingButton";

const RecipeBanner: React.FC = () => {
  const [ratingModalIsOpen, setRatingModalIsOpen] = useState(false);
  const openRatingModal = () => setRatingModalIsOpen(true);
  const closeRatingModal = () => setRatingModalIsOpen(false);

  return (
    <div className="main-banner">
      <img src="/images/banner.png" alt="banner" width={390} height={240} />
      <div className="banner-buttons">
        <RatingButton onClick={openRatingModal} />
        <ShareButton />
      </div>
      <RatingModal
        isOpen={ratingModalIsOpen}
        onRequestClose={closeRatingModal}
      />
    </div>
  );
};

export default RecipeBanner;
